import React, { useEffect } from "react";
import BreadCrumb from "../../../../layout/BreadCrumb";
import Header from "./Header";
import AboutScheme from "./AboutScheme";
import { useDispatch, useSelector } from "react-redux";
import { fetchMrktHow } from "../../../../features/fetch/fetchSlice";

function AsalSchemeViewList() { 
  const dispatch =  useDispatch()
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["asalSchemes"],
  }));
    useEffect(() => { 
      dispatch(fetchMrktHow())
    }, []);

  return (
    <div>
      <BreadCrumb
        breadcrumbs={[
          { title: "Schemes Overview", path: "/scheme/scheme-overview" },
          { title: "Asal", path: "/scheme/asal-scheme" },
          { title: `View ${activeObjSchemes?.schName}` }
        ]}
      />

      <Header />
      <AboutScheme />
    </div>
  );
}

export default AsalSchemeViewList;
